import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../config';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { v4 as uuidv4 } from 'uuid';

const ChangeContact = ({ caseId, onClose, action, companyName, caseType }) => {
    const [showAddContact, setShowAddContact] = useState(false);
    const [contacts, setContacts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isInvited, setIsInvited] = useState([]);
    const [isDisable, setIsDisable] = useState(false);
    const [newContact, setNewContact] = useState({
        firstName: '',
        lastName: '',
        company: '',
        contactType: '',
        email: ''
    });
    const [formError, setFormError] = useState('');
    const [contactTypes, setContactTypes] = useState([
        'Client',
        'Broker',
        'Collaborator'
    ]);

    useEffect(() => {
        if (!caseId) return;

        const fetchContacts = async () => {
            try {
                const response = await axios.get(`${config.API_URL}/CaseContacts/ByCaseId/${caseId}`);
                setContacts(response.data);
            } catch (err) {
                setError('Failed to fetch contacts');
            } finally {
                setLoading(false);
            }
        };

        fetchContacts();
    }, [caseId]);

    const toggleContact = () => {
        setShowAddContact(!showAddContact);
        setFormError(''); // Reset form error when toggling
    };

    const handleInvite = async (contactId) => {

        try {
            const response = await axios.put(`${config.API_URL}/CaseContacts/AddCollaborator/${contactId}`);
            setIsInvited(prevState => [...prevState, contactId]);
        } catch (err) {
            setError('Failed to invite');
        }

    }

    const handleChangeContact = async (contact) => {

        try {
            const response = await axios.post(`${config.API_URL}/RenewalPortal/RenewalContactChange`, {

                firstName: contact?.contactFirstName,
                lastName: contact?.contactLastName,
                email: contact?.contactEmail,
                contactType: contact?.contactType,
                newContact: contact.sfContactId === '' ? true : false,
                caseId: contact?.caseId,
            });

            const patchDocument = [
                { op: 'replace', path: '/isInvited', value: true },
            ];
            const url = `${config.API_URL}/CaseContacts/${contact?.caseContactId}`;
            await axios.patch(url, patchDocument);
            setIsInvited(prevState => [...prevState, contact?.caseContactId]);
            setIsDisable(true);
        } catch (err) {
            setError('Failed to change');
        }

    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewContact({ ...newContact, [name]: value });
    };

    const handleAddContact = async () => {
        const { firstName, lastName, company, contactType, email } = newContact;


        if (!firstName || !lastName || !contactType || !email) {
            setFormError('All fields are required');
            return;
        } else if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
            setFormError('Invalid email format');
            return;
        }

        try {

            const response = await axios.post(`${config.API_URL}/RenewalPortal/RenewalContactChange`, {

                firstName: firstName,
                lastName: lastName,
                email: email,
                contactType: contactType,
                newContact: true,
                caseId: caseId,
            });

            //setContacts([...contacts, response.data]);
            setShowAddContact(false);
            setNewContact({
                firstName: '',
                lastName: '',
                contactType: '',
                email: ''
            });
        } catch (err) {
            setFormError('Failed to add contact');
        }
    };

    return (
        <div id="myModal2" className="modal">
            <div className="modal-content">
                <span id="invite-close" className="close" onClick={onClose}>&times;</span>

                {action === "invite" ? (
                    <>
                        <div className="header">
                            <h5 className="card-title">Invite Others to Assist with Your Renewal</h5>
                        </div>
                        <div className="about-content">
                            <p>
                                Below is a list of contacts we have associated with your account.
                                If you would like someone in this list to collaborate on your renewal, simply click Invite.
                                Once invited, they will receive an email with instructions for accessing the Clarity Portal and renewal tool.
                                If the person you would like to invite is not listed, click Add New Contact,
                                enter their information and we will send them an invitation.
                            </p>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="header">
                            <h5 className="card-title">Change Main Renewal Contact</h5>
                        </div>
                        <div className="about-content">
                            <p>
                                Our records indicate that the primary renewal contact is the person listed below.
                                This means they are the person responsible for the renewal and the person who will receive all related communications.
                                If this is not the correct contact, click Change Renewal Contact and we will update our records accordingly.
                            </p>
                        </div>
                    </>
                )}

                <div className={`table-responsive mb-3 ${showAddContact ? 'd-none' : ''}`} id="collaborators-contacts">
                    {loading ? (
                        <Skeleton count={5} />
                    ) : error ? (
                        <p>{error}</p>
                    ) : (
                        <table className="modal-table table table-fixed">
                            <thead>
                                <tr>
                                    <th scope="col" style={{ width: '16.67%' }}>First Name</th>
                                    <th scope="col" style={{ width: '16.67%' }}>Last Name</th>
                                    <th scope="col" style={{ width: '16.67%' }}>Company</th>
                                    <th scope="col" style={{ width: '16.67%' }}>Type</th>
                                    <th scope="col" style={{ width: '16.67%' }}>Email</th>
                                    <th scope="col" style={{ width: '16.67%' }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {contacts.map(contact => (
                                    <tr key={contact?.sfContactId}>
                                        <td>{contact?.contactFirstName}</td>
                                        <td>{contact?.contactLastName}</td>
                                        <td>{companyName}</td>
                                        <td>{contact?.contactType}</td>
                                        <td>{contact?.contactEmail}</td>
                                        <td>

                                            {action === "invite" ? (
                                                <>

                                                    {
                                                        (caseType === "COBRA" ? contact?.oE_Cobra === "1" : contact?.oE_EB === "1") ? (
                                                            <strong><em>Primary Renewal Contact</em></strong>
                                                        ) : (!contact.isCollaborator ? (
                                                            <button
                                                                className="btn btn-primary"
                                                                disabled={isInvited.includes(contact?.caseContactId)}
                                                                onClick={() => handleInvite(contact?.caseContactId)}
                                                            >
                                                                {isInvited.includes(contact?.caseContactId) ? 'Invited' : 'Invite'}
                                                            </button>
                                                        ) : (
                                                            <strong><em>Invited</em></strong>
                                                        ))
                                                    }



                                                </>) : (
                                                <>

                                                    {(caseType === "COBRA" ? contact?.oE_Cobra === "1" : contact?.oE_EB === "1") ? (
                                                        <strong><em>Primary Renewal Contact</em></strong>
                                                    ) : (
                                                        (!contact.isInvited && !contacts.some(contact => contact.isInvited)) ? (
                                                            !isDisable ? (
                                                                <button
                                                                    className="btn btn-primary"
                                                                    onClick={() => handleChangeContact(contact)}
                                                                >
                                                                    Change Renewal contact
                                                                </button>
                                                            ) : (
                                                                isInvited.includes(contact?.caseContactId) ? (
                                                                    <strong><em>Change contact initiated</em></strong>
                                                                ) : (
                                                                    <></>
                                                                )
                                                            )
                                                        ) : (
                                                            contact.isInvited ? (
                                                                <strong><em>Change contact initiated</em></strong>
                                                            ) : (
                                                                <></>
                                                            )
                                                        )
                                                    )}



                                                </>
                                            )}


                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
                <div className={`table-responsive mb-3 ${showAddContact ? '' : 'd-none'}`} id="companyContactsPopupContainer">
                    <h2 className="card-title">Add Contact</h2>
                    <table className="modal-table table table-fixed">
                        <thead>
                            <tr>
                                <th scope="col" style={{ width: '16.67%' }}>First Name</th>
                                <th scope="col" style={{ width: '16.67%' }}>Last Name</th>
                                <th scope="col" style={{ width: '16.67%' }}>Company</th>
                                <th scope="col" style={{ width: '16.67%' }}>Type</th>
                                <th scope="col" style={{ width: '16.67%' }}>Email</th>
                                <th scope="col" style={{ width: '16.67%' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><input type="text" className='form-control' name="firstName" value={newContact.firstName} onChange={handleInputChange} /></td>
                                <td><input type="text" className='form-control' name="lastName" value={newContact.lastName} onChange={handleInputChange} /></td>
                                <td>{companyName}</td>
                                <td>
                                    {action === 'invite' ? (<>Collaborator</>) : (<>
                                        <select
                                            name="contactType"
                                            value={newContact.contactType}
                                            onChange={handleInputChange}
                                            className="form-control"
                                            required
                                        >
                                            <option value="">Select Type</option>
                                            {contactTypes.map(type => (
                                                <option key={type} value={type}>
                                                    {type}
                                                </option>
                                            ))}
                                        </select></>)}</td>
                                <td><input type="email" className='form-control' name="email" value={newContact.email} onChange={handleInputChange} /></td>
                                <td>
                                    <button className="btn btn-success" onClick={handleAddContact}>Save Contact</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    {formError && <div className="invalid-feedback d-block">{formError}</div>}
                </div>
                <div className="modal-btns">
                    <div className="row mb-3">
                        <div className="col-md-6">

                            {action === 'invite' ? (<></>) : (<>

                                {!contacts.some(contact => contact.isInvited) ?
                                    (
                                        !isDisable ? (
                                            <button
                                                id="toggleContactBtn"
                                                onClick={toggleContact}
                                                className="btn btn-primary modal-button float-start"
                                            >
                                                {showAddContact ? 'Back to Contacts' : 'Add New Contact'}
                                            </button>
                                        ) : (<></>)
                                    ) : (<></>)}


                            </>)}

                        </div>
                        <div className="col-md-6">
                            <button
                                className="btn btn-success modal-button float-end"
                                onClick={onClose}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(ChangeContact);
